import { ReadConfirmation } from "../../types/readconfirmation/readconfirmation";
import { namespace as readListNamespace, ConfirmationParameters } from "../modules/readList/read-list";
import { Store } from "vuex";
import { ActionResult } from "@/todos";

export class ReadListStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the read confirmation list */
    public get list(): ReadConfirmation[] {
        return this.store.getters[`${readListNamespace}/list`];
    }

    /** Gets the last read confirmation */
    public get lastConfirmed(): ConfirmationParameters {
        return this.store.getters[`${readListNamespace}/lastConfirmed`];
    }

    /** Confirm reading the document */
    public async updateReadConfirmation(confirm: ConfirmationParameters): Promise<ActionResult<void, string>> {
        return this.store.dispatch(`${readListNamespace}/updateReadConfirmation`, confirm);
    }

    /** loads the confirmation read list */
    public async loadListAsync(): Promise<void> {
        return this.store.dispatch(`${readListNamespace}/loadListAsync`);
    }
}
